import { IconType, SvgIcon } from './SvgIcon';

export const FilledDotIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 12 12">
    <circle cx="6" cy="6" r="4" fill="currentColor" />
    <circle cx="6" cy="6" r="5.5" fill="none" stroke="currentColor" strokeWidth={1} />
  </SvgIcon>
);

FilledDotIcon.displayName = 'FilledDotIcon';
